<template>
  <div class="news_bar">
    <div class="item" v-for="item in newsList" :key="item.articleId">
      <img :src="item.coverImg" @click="clickItem(item.articleId)" />
      <div @click="clickItem(item.articleId)">{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      newsList: [],
    };
  },
  methods: {
    reqArticleList() {
      axios.get("./data.json").then((res) => {
        this.newsList = res.data.articleList;
        console.log(this.newsList);
      });
    },
    clickItem(id) {
      this.$router.push({
        path: `/article?id=${id}`,
      });
    },
  },
  mounted() {
    this.reqArticleList();
  },
};
</script>

<style scoped>
.news_bar {
  width: 1000px;
  margin: 20px auto 0;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  background-color: #fff;
}
.item {
  flex: 1;
  height: 150px;
  text-align: center;
  border-right: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.item img {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.item div {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*超出两行省略*/
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
.item:last-child {
  border-right: 1px solid transparent;
}
</style>
